(function ($) {
  
  'use strict';
  
  /**
   * -------------------------------
   * GENERAL - GLOBAL VARIABLES
   * -------------------------------
   */
  
  var $window = $(window),
      position = $window.scrollTop(),
      last_scroll_direction = '',
      win_height_padded = $window.height() * 1.1;   
  
  /**
   * -------------------------------
   * GENERAL - HELPER FUNCTIONS
   * -------------------------------
   */

  // Retourne "true" si la page actuelle est la page d'accueil
  function isHomePage() {
    var url = window.location.pathname;
    
    if(url == '/') {
      return true;
    } else {
      return false;
    }
  }

  // Retourne "true" si la page actuelle est la page "pageHandle"
  function isPage(pageHandle) {
    var url = window.location.href;
    
    if(url.indexOf(pageHandle) != -1) {
      return true;
    } else {
      return false;
    }
  }
  
  // Convertit une string en prix
  function convertToPriceFormat(amount) {
    var domain = window.location.hostname,        
        amout_without_trailing_zeros = amount,
        amout_with_trailing_zeros = amount,
        trailing_zeros = 0;
    
  	amount = amount / 100; // Met le bon format
    amout_without_trailing_zeros = amount.toFixed();
    amout_with_trailing_zeros = amount.toFixed(2);    
    trailing_zeros = amout_with_trailing_zeros - amout_without_trailing_zeros;
    
    if(trailing_zeros == 0) {
      amount = amout_without_trailing_zeros; // Retire les décimales
    } else {
      amount = amout_with_trailing_zeros; // Ajoute les décimales
    }
    amount = amount.replace('.', ','); // Remplace le point par la virgule
    
    switch (domain) {
      case 'liaderma.fr':
        amount += ' €';
        break;
      default:
        amount += '€';
    }
    
    return amount;
  }
  
  // Retourne la direction du scroll vertical
  function getVerticalScrollDirection() {
    var scrolled = $window.scrollTop(),
        vertical_scroll_direction = '';
    
    if(scrolled > position) {
      vertical_scroll_direction = 'down';
    } else if(scrolled < position) {
      vertical_scroll_direction = 'up';
    } else if(last_scroll_direction == 'down') {
   	  vertical_scroll_direction = 'down';
    } else if(last_scroll_direction == 'up') {
   	  vertical_scroll_direction = 'up';
    } else {
      vertical_scroll_direction = 'down';
    }
    
    position = scrolled;
    last_scroll_direction = vertical_scroll_direction;
    return vertical_scroll_direction;
  }
  
  // Scroll en haut de la page
  function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  
  // Scroll en haut de la popup
  function scrollToTopModal($this) {
    var modal = $this.closest('.modal').get(0);
	modal.scrollIntoView(true);
  }
  
  // Fixe le cta
  function fixCta($this) {
  	$this.addClass('animated slide-in-up');
    $this.css('position', 'fixed');
    $('.footer').addClass('footer--fixed');
  }
  
  // Défixe le cta
  function unfixCta($this) {
    $this.removeClass('animated slide-in-up');
    $this.css('position', 'unset');
    $('.footer').removeClass('footer--fixed');
  }
  
  // Anime une sous-texte d'une bullet point
  function animateTexts($this) {
    var dynamic_bullet_points = $this.find('.bullet-point'),
        dynamic_bullet_points_size = dynamic_bullet_points.length - 1,
        delay = 5000,
        i = 0;
    
    dynamic_bullet_points.eq(i).addClass('animated');
    i += 1;
    
    setInterval(function() {  
      dynamic_bullet_points.each(function() {
        $(this).removeClass('animated');
      });
      
	  dynamic_bullet_points.eq(i).addClass('animated');
      
      if(i == dynamic_bullet_points_size) {
        i = 0;
      } else {
      	i += 1;
      }
    }, delay);
  }
  
  /**
   * -------------------------------
   * GENERAL - LOAD
   * -------------------------------
   */
  
  // Démarre le carousel des slideshows
  function startSlideshowCarousels() {
    var slideshow_carousels = $('.image-with-text-carousel'),
        slides_to_show_scroll = 1,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    slideshow_carousels.each(function() {
      var carousel = $(this),
          autoplay = carousel.data('auto-play'),
          arrows = carousel.data('arrows');

      carousel.slick({
        adaptiveHeight: true,
        autoplay: autoplay,
        autoplaySpeed: 5000,
        arrows: arrows,
        centerMode: false,
        dots: false,
        draggable: true,
        infinite: false,
        slidesToShow: slides_to_show_scroll,
        slidesToScroll: 1,
        speed: 300,
        swipe: true,
        swipeToSlide: false,
        touchThreshold: 5,
        useCSS: false,
        useTransform: true,
        prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
        nextArrow: '<button class="slick-next">' + next_arrow + '</button>'
      });
    });
  }
  
  // Démarre le carousel de la liste des produits featured
  function startFeaturedProductListCarousels() {
    var product_list_carousels = $('.product-list-products--carousel'),
        slides_to_show_scroll = 4,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    product_list_carousels.each(function() {
      var carousel = $(this),
          carousel_items = carousel.find('.product-item'),
          carousel_items_size = carousel_items.length,
          initial_slide = 0;
      
      if(carousel_items_size > 3) {
      	initial_slide = 2;
      }

      carousel.slick({
        autoplay: false,
        arrows: true,
        centerMode: true,
        dots: false,
        draggable: true,
        infinite: false,
        initialSlide: initial_slide,
        slidesToShow: slides_to_show_scroll,
        slidesToScroll: 1,
        speed: 750,
        swipe: true,
        swipeToSlide: false,
        touchThreshold: 5,
        useCSS: false,
        useTransform: true,
        prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
        nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
        responsive: [
          {
            breakpoint: 500,
            settings: {
              centerMode: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              speed: 500
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }
  
  // Démarre le carousel de la liste des produits addon (sur la page panier)
  function startAddonProductListCarouselsCartPage() {
    var product_list_carousels = $('.template-cart').find('.main').find('.cart-addon-products--carousel'),
        slides_to_show_scroll = 3,
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0-11,9.82,0,19" transform="translate(12.5 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="14.618" height="23.231" viewBox="0 0 14.618 23.231"><path id="Path_4" data-name="Path 4" d="M0,0,11,9.82,0,19" transform="translate(2.118 2.118)" fill="none" stroke="#9FDAF3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3"/></svg>';

    product_list_carousels.each(function() {
      var carousel = $(this);

      carousel.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        centerMode: false,
        dots: false,
        draggable: true,
        infinite: false,
        slidesToShow: slides_to_show_scroll,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchThreshold: 5,
        useCSS: false,
        useTransform: true,
        prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
        nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      });
    });
  }
  
  // Démarre le carousel de la liste des produits
  function startProductListCarousels() {
    startFeaturedProductListCarousels();
    startAddonProductListCarouselsCartPage();
  }
  
  // Démarre les carousels des sections de type "Texte + Carousel"
  function startTxtCrslSectionsCarousels() {
    var txt_crsl_sections = $('.text-with-carousel'),
        slides_to_scroll = 1,
        slides_to_show_1921 = 2,
        center_padding_desktop = '0',
        center_padding_361 = '20px',
        center_padding_500 = '40px',
        prev_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0-14,14.988,0,29" transform="translate(17 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>',
        next_arrow = '<svg class="icon icon--custom" xmlns="http://www.w3.org/2000/svg" width="21.243" height="37.483" viewBox="0 0 21.243 37.483"><path id="Path_4" data-name="Path 4" d="M0,0,14,14.988,0,29" transform="translate(4.243 4.24)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/></svg>';

    txt_crsl_sections.each(function() {
      var txt_crsl_section = $(this),
          carousel = txt_crsl_section.find('.carousel'),
          arrows = carousel.data('arrows'),
          slides_to_show_mobile = parseInt(carousel.data('items-mobile')),
          slides_to_show_desktop = parseInt(carousel.data('items-desktop'));

      if(txt_crsl_section.hasClass('carousel--remove-spaces-true')) {
        slides_to_show_desktop = slides_to_show_desktop;
      }
      
      if(carousel.hasClass('reviews--carousel')) {
        center_padding_361 = '60px';
        center_padding_500 = '80px';
      }
      
      if(carousel.hasClass('zoom_images--carousel')) {
        center_padding_desktop = '80px';
      }

      carousel.slick({
        adaptiveHeight: false,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: arrows,
        centerMode: true,
        centerPadding: center_padding_desktop,
        dots: false,
        draggable: true,
        infinite: true,
        slidesToShow: slides_to_show_desktop,
        slidesToScroll: slides_to_scroll,
        touchThreshold: 4,
        prevArrow: '<button class="slick-prev">' + prev_arrow + '</button>',
        nextArrow: '<button class="slick-next">' + next_arrow + '</button>',
        responsive: [
          {
            breakpoint: 500,
            settings: {
              centerMode: true,
              centerPadding: center_padding_500,
              slidesToShow: slides_to_show_mobile
            }
          },
          {
            breakpoint: 361,
            settings: {
              centerMode: true,
              centerPadding: center_padding_361,
              slidesToShow: slides_to_show_mobile
            }
          }
        ]
      });
      
      // Ajuste la hauteur de la partie texte de la section "Texte + Carousel"
      if(window.innerWidth >= 500) {
        var carousel_part = carousel.closest('.text-with-carousel__carousel-wrapper'),
            carousel_part_height = carousel_part.height(),
            text_part = carousel_part.siblings('.text-with-carousel__text-wrapper').eq(0);

        text_part.css('height', carousel_part_height);
      }
    });
  }
  
  // Fixe les ctas
  function fixCtaOnLoad(e) {
    // Fixe les ctas fixes si on revient sur cette page sur une ancre basse
    var scrolled = $window.scrollTop(),
        cta_animated = $('.fix-cta-on-scroll.animated'),
        trigger = $('.trigger-sticky-form').eq(0);
    
    cta_animated.each(function() {
      var $this = $(this),
          offset_top = trigger.offset().top;
      
      if (scrolled > offset_top) {
        unfixCta($this);
      }
    });
  }
  
  // Fixe le cta de la page d'accueil au scroll
  function fixCtaOnScroll(e) {
    var scrolled = $window.scrollTop(),
        cta_animated = $('.fix-cta-on-scroll.animated'),
        cta_not_animated = $('.fix-cta-on-scroll:not(.animated)'),
        trigger = $('.trigger-sticky-form').eq(0);
    
    $(cta_not_animated).each(function () {
      var $this = $(this),
          offset_top = trigger.offset().top;

      if (scrolled > offset_top) {
        if ($this.data('timeout')) {
          window.setTimeout(function(){
            fixCta($this);
          }, parseInt($this.data('timeout'), 10));
        } else {
          fixCta($this);
        }
      }
    });
    
    $(cta_animated).each(function () {
        var $this = $(this),
            offset_top = trigger.offset().top;
      
        if (scrolled < offset_top) {
          unfixCta($this);
        }
    });
  }
  
  // Démarre les différents carousels
  function startCarousels(e) {
    startSlideshowCarousels();
    startProductListCarousels();
    startTxtCrslSectionsCarousels();
  }
  
  // Affiche les sous-textes des bullet points successivement
  function startDynamicTexts(e) {
    var dynamic_bullet_points = $('.bullet-points--dynamic');
    
    dynamic_bullet_points.each(function() {
      var $this = $(this);
      
      animateTexts($this);
    });
  }
  
  // Au load d'une page
  function _loadListener(e) {
    startCarousels(e);
    startDynamicTexts(e);
    fixCtaOnLoad(e);
    fixCtaOnScroll(e);
  }
  
  // Au load d'une page
  $window.on('load', function(e) {
    _loadListener(e);
  });
  
  /**
   * -------------------------------
   * GENERAL - SCROLL
   * -------------------------------
   */
  
  // Au scroll d'une page
  function _scrollListener(e) {
    fixCtaOnScroll(e);
  }
  
  // Au scroll d'une page
  $window.on('scroll', function(e) {
    _scrollListener(e);
  });
  
  /**
   * -------------------------------
   * GENERAL - READ MORE LINKS
   * -------------------------------
   */
  
  // Affiche tout le contenu texte associé
  function showFullContent($this, e) {
  	var is_block = $this.data('block'),
        button_text = $this.find('.button--text');
    
    e.preventDefault();
    
    if(!is_block) {
      var section = $this.closest('.section'),
          content_full = section.find('.section__content-full').eq(0),
          content_bullet_points = section.find('.section__content-bullet-points').eq(0);
      
      content_full.slideToggle();
      content_bullet_points.slideToggle();
      $this.closest('.button-group').remove();
    } else {
      var section_wrapper = $this.closest('.section-wrapper'),
          content_full = section_wrapper.find('.section__content-full').eq(0);

      content_full.slideToggle();
    }
    
    // Vérifie si on doit changer le texte du bouton    
    if(button_text.text() == '+') {
      button_text.text('-');
    } else if(button_text.text() == '-') {
      button_text.text('+');
    }
  }
  
  // Au clic sur un lien "read_more"
  function _clickReadMoreLinkListener($this, e) {
    showFullContent($this, e);
  }
  
  // Au clic sur un lien "read_more"
  $(document).on('click', 'a[href="#read_more"]', function(e) {
    _clickReadMoreLinkListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SNIPPET - IMAGE WITH TEXT
   * -------------------------------
   */
  
  // Change la position de l'image de comparaison // MAJ
  function changeImageComparePosition($this, e) {
	var section = $this.closest('.section'),
        separator = $this.parent().find('.separator'),
        icon = $this,
        image_compare = section.find('.compare').find('img');
    
    
  }
  
  // Au drag du bouton de comparaison
  function _dragCompareIconListener($this, e) {
    changeImageComparePosition($this, e);
  }
  
  // Au drag du bouton de comparaison
  $(document).on('draggable', '.icon--slide-compare', function(e) {
    _dragCompareIconListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SNIPPET - IMAGE WITH TEXT CAROUSEL
   * -------------------------------
   */
  
  // Affiche le slide associé à l'item de navigation
  function changeImageWithTextCarouselSlide($this, e) {
	var slide_index = $this.data('index'),
        carousel = $this.closest('.section').find('.carousel');
    
    $this.parent().find('.image-with-text-carousel-navigation-item.active').removeClass('active');
    $this.addClass('active');
    carousel.slick('slickGoTo', slide_index);
  }
  
  // Au clic sur un item de navigation
  function _clickCarouselNavigationItemListener($this, e) {
    changeImageWithTextCarouselSlide($this, e);
  }
  
  // Au clic sur un item de navigation
  $(document).on('click', '.image-with-text-carousel-navigation-item', function(e) {
    _clickCarouselNavigationItemListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SNIPPET - INGREDIENT ITEM
   * -------------------------------
   */
  
  // Affiche ou cache tout le contenu texte associé
  function toggleIngredient($this, e) {
  	var ingredient_item = $this.closest('.ingredient-item'),
     	image_wrapper = ingredient_item.find('.ingredient-image__wrapper'),
        text_wrapper = ingredient_item.find('.ingredient-text__wrapper'),
        ingredient_overlay = text_wrapper.find('.ingredient-overlay'),
        ingredient_details = text_wrapper.find('.ingredient-details'),
        button_wrapper = ingredient_item.find('.ingredient-button__wrapper'),
        button = button_wrapper.find('.button');        
    
    // Vérifie si on doit changer le texte du bouton    
    if(button.text() == '+') {
      button.text('-');
      image_wrapper.css('opacity', 0);
    } else if(button.text() == '-') {
      button.text('+');
      image_wrapper.css('opacity', 1);
    }
    
    ingredient_overlay.toggle();
    ingredient_details.toggle();
  }
  
  // Au clic sur le bouton "+" d'un ingrédient
  function _clickToggleIngredientListener($this, e) {
    toggleIngredient($this, e);
  }
  
  // Au clic sur le bouton "+" d'un ingrédient
  $(document).on('click', '[data-action="toggle-ingredients"]', function(e) {
    _clickToggleIngredientListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SNIPPET - QUESTIONS
   * -------------------------------
   */
  
  // Affiche ou cache la réponse d'une question
  function toggleAnswer($this) {
    var faq_item = $this.closest('.faq__item');
    
    if(faq_item.attr('aria-hidden') == 'true') {
    	faq_item.attr('aria-hidden', 'false');
    } else {
    	faq_item.attr('aria-hidden', 'true');
    }
    
    $this.next('.faq__answer').slideToggle(250);    
  }
  
  // Au clic sur une question
  function _clickQuestionListener($this) {
    toggleAnswer($this);
  }
  
  // Au clic sur une question
  $(document).on('click', '.faq__question', function(e) {
    _clickQuestionListener($(this));
  });
  
  /**
   * -------------------------------
   * SECTION - META FORM - Ajout au panier
   * -------------------------------
   */
  
  // Ajoute une variante à la file d'attente
  function addVariantToQueue(variant_id, variant_quantity, variant_properties){
    if(variant_properties == '') {
      variant_properties = new Object();
    }
    
    Shopify.queue.push({
      variantId: variant_id,
      quantity: variant_quantity,
      properties: variant_properties
    });
  }
  
  // Pousse la file d'attente au panier
  Shopify.moveAlong = function() {
    // Si nous avons encore des demandes dans la file d'attente, traitons la prochaine
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift(),
          data = {};

      if(request.properties) {
        data = {
          id: request.variantId,
          quantity: request.quantity,
          properties: request.properties
        };
      }
      else {
        data = {
          id: request.variantId,
          quantity: request.quantity
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function(response) {
          if (Shopify.queue.length){
            Shopify.moveAlong();
          } else {
            if(isPage('/cart')) {
               // On rafraichit la page panier
               location.reload();
            } else {
               // On lance un événement pour que le mini-panier puisse effectuer des traitements supplémentaires, comme le réaffichage du mini-panier.
               $(document).trigger('product.added');
          	}
          } 
        },
        error: function(response) {
          alert(response.responseJSON.description); // Afficher les erreurs dans la boîte de dialogue

          // Si ce n'est pas le dernier, on rappelle la fonction Move Along
          if (Shopify.queue.length){
            Shopify.moveAlong();
          }
        }
      });
    } else {
      // On lance un événement pour que le mini-panier puisse effectuer des traitements supplémentaires, comme le réaffichage du mini-panier.
      $(document).trigger('product.added');
    }
  };
  
  // Ajoute une variante au panier
  function addVariantToCart(variant_id, variant_quantity, variant_properties) {
    // Définit la file d'attente vide
    Shopify.queue = [];
    
    // Ajoute les snacks dans la file d'attente
    addVariantToQueue(variant_id, variant_quantity, variant_properties);
    
    // Pousse la file d'attente au panier
    Shopify.moveAlong();
  }
  
  // Ajoute un produit au panier
  function addToCartAjax($this, e) {
    var variant_id = $this.data('variant-id'),
    	variant_quantity = 1,
    	variant_properties = '',
        custom_quantity = parseInt($this.closest('.product-form').find('.product-quantity-value').text());
    
    if(custom_quantity) {
      variant_quantity = custom_quantity;
    }
    
    e.preventDefault();
    addVariantToCart(variant_id, variant_quantity, variant_properties);
  }
  
  // Au clic sur un bouton d'ajout au panier
  function _clickAddToCartAjaxListener($this, e) {
    addToCartAjax($this, e);
  }
  
  // Au clic sur un bouton d'ajout au panier
  $(document).on('click', '[data-action="add-to-cart-ajax"]', function(e) {
    _clickAddToCartAjaxListener($(this), e);
  });
  
  /**
   * -------------------------------
   * SECTION - META FORM - Product
   * -------------------------------
   */
  
  // Ajoute 1 à la quantité de l'item
  function addQuantity($this) {
    var quantity_item = $this.siblings('.quantity-product'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value + 1;
    
    quantity_item.text(new_value);
  }
  
  // Enlève 1 à la quantité de l'item
  function subQuantity($this) {    
    var quantity_item = $this.siblings('.quantity-product'),
        quantity_value = parseInt(quantity_item.text()),
        new_value = quantity_value - 1;
    
    if(new_value > 0) {
      quantity_item.text(new_value);
    }
  }
  
  // Au clic sur le - de la quantité 
  function _clickSubQuantityListener($this) {
    subQuantity($this)
  }
  
  // Au clic sur le + de la quantité 
  function _clickAddQuantityListener($this) {
    addQuantity($this);
  }  
  
  // Au clic sur le - de la quantité
  $(document).on('click', '.button--sub-product', function(e) {
	_clickSubQuantityListener($(this));
  });
  
  // Au clic sur le + de la quantité 
  $(document).on('click', '.button--add-product', function(e) {
	_clickAddQuantityListener($(this));
  }); 
  
}(jQuery));